import { render } from "./approval_post.html?vue&type=template&id=f69fbfe4&external"
import script from "./approval_post.js?vue&type=script&lang=js&external"
export * from "./approval_post.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__